/* =========================================================================
   Feature flags — temporary kill-switches for surfaces that are built but not
   yet cleared for release. Kept as a LEAF module (no imports) so any module can
   gate on a flag without creating an import cycle.
   ========================================================================= */

/** "The Pilgrimage" (the map screen + the Today's-Pilgrimage quest card + the
    home station CTA / explainer entry points).

    LIVE as of Path v1 (PLAN-levels-path.md): the next incomplete station is the
    primary home CTA (pathHome.ts), the stations meter + reward preview sit with
    it, and the hub tiles render as a sidebar strip. Flipping this back to false
    restores the previous home verbatim — every Pilgrimage surface (home CTA,
    quest card, results journey card, map) gates on this one switch. */
export function isPilgrimageEnabled(): boolean {
  return true;
}

/** "Friendly Play" — the education-only study surface (PLAN-gameplay-round2.md
    Part 2): a category × level picker and an untimed, scoreless question set.

    DEFAULT ON: it is purely additive (a new screen pair + one quiet home entry)
    and touches nothing the scored game owns — no wallet, no XP, no streak, no
    breaks. Flipping this to false hides the home button and the hub tile, which
    are its only entry points, leaving home exactly as Path v1 renders it. */
export function isFriendlyPlayEnabled(): boolean {
  return true;
}

/** Optional art/video (chapel restoration stages, the feast-frame loop, the
    pilgrimage map + intro video) isn't in public/media/ yet. While false, screens
    skip probing for it and use their built-in CSS fallbacks — which stops the
    boot-time 404 noise from feature-detection. Flip to true once the files land. */
export function hasOptionalMedia(): boolean {
  return false;
}
